import { render, staticRenderFns } from "./CInternationalTelephoneInput.vue?vue&type=template&id=1c8a883f&scoped=true&"
import script from "./CInternationalTelephoneInput.vue?vue&type=script&lang=ts&"
export * from "./CInternationalTelephoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./CInternationalTelephoneInput.vue?vue&type=style&index=0&id=1c8a883f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a883f",
  null
  
)

export default component.exports